module.exports = __webpack_public_path__ + "static/media/h.8d1e1958.svg";